<app-page-header title="Dunaszentmiklósi önkormányzat"></app-page-header>

<div class="main-page-nav mt-5 px-3">
  <div class="row justify-content-around px-3">
    <div class="sub-nav-item">
      <div
        class="col-md p-3 mx-2 text-center"
        routerLink="/main-council/documents"
        routerLinkActive="active"
      >
        <i class="fas fa-file-alt"></i>
        <p class="mt-3">Önkormányzati dokumentumok</p>
      </div>
    </div>
    <div class="sub-nav-item">
      <div
        class="col-md p-3 mx-2 text-center"
        routerLink="/main-council/main-tasks"
        routerLinkActive="active"
      >
        <i class="fas fa-tasks"></i>
        <p class="mt-3">Önkormányzat feladatai és szakfeladatok</p>
      </div>
    </div>
    <div class="sub-nav-item">
      <div
        class="col-md p-3 mx-2 text-center"
        routerLink="/main-council/officers"
        routerLinkActive="active"
      >
        <i class="fas fa-users"></i>
        <p class="mt-3">Dolgozók és Képviselő testület</p>
      </div>
    </div>
    <div class="sub-nav-item">
      <div
        class="col-md p-3 mx-2 text-center"
        routerLink="/main-council/seconded"
        routerLinkActive="active"
      >
        <i class="fas fa-sitemap"></i>
        <p class="mt-3">Felettes szervek</p>
      </div>
    </div>
    <div class="sub-nav-item">
      <div
        class="col-md p-3 mx-2 text-center"
        routerLink="/main-council/council-information"
        routerLinkActive="active"
      >
        <i class="fas fa-info-circle"></i>
        <p class="mt-3">Közérdekű információk</p>
      </div>
    </div>
  </div>
</div>

<div
  class="content my-3"
  [@routeAnimations]="
    o && o.activatedRouteData && o.activatedRouteData['animation']
  "
>
  <router-outlet #o="outlet"></router-outlet>
</div>
